import fetch from 'isomorphic-unfetch';
async function get(baseUrl, opts) {
  const response = await fetch(`${baseUrl}/api/subscriptions`, opts);
  return response.ok ? await response.json() : null;
}

const createSubscription = async (
  travel,
  beneficiaries,
  subscriber,
  token,
  submittedOn,
  affiliateId,
  controller = undefined
) => {
  const result = await fetch('/api/subscriptions', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      stay: travel,
      beneficiaries: beneficiaries,
      subscriber: subscriber,
      token: token,
      affiliateId: affiliateId,
      submittedOn: submittedOn
    }),
    credentials: 'include',
    signal: controller ? controller.signal : undefined
  }).then(res => {
    return res.ok
      ? res.json().then(json => {
          res.id = json.id;
          return res;
        })
      : res;
  });
  return result;
};

const updateCountry = async (subscriptionId, destination) => {
  try {
    const result = await fetch(`/api/subscriptions/${subscriptionId}/country`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(destination),
      credentials: 'include'
    });
    return result;
  } catch (err) {
    return false;
  }
};

const subscriptions = {
  get,
  createSubscription,
  updateCountry
};
export default subscriptions;
